import './ErrorPage.scss'
import SubmitButton from './buttons/SubmitButton'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { ReactComponent as Op36Logo } from '../../assets/images/logos/horizontal-logo.svg'

const ErrorPage = ({ removeError }) => {
  const { t } = useTranslation()

  const handleClick = () => {
    removeError()
    window.location.reload()
  }

  return (
    <div id='ErrorPage'>
      <div className='header'>
        <Op36Logo className='op36-logo'/>
      </div>
      <div className='main-content'>
        <i className='fa fa-exclamation-triangle error-icon'/>
        <p className='error-title'>{t('common.errorPage.title')}</p>
        <p className='error-text'>{t('common.errorPage.text')}</p>
        <div className='error-message-box'>
          <p className='error-primary-text'>{t('common.errorPage.needHelp')}</p>
          <p className='error-secondary-text'>{t('common.errorPage.email', { email: 'support@op36golf.com' })}</p>
        </div>
        <div className='main-button'>
          <SubmitButton
            onClick={handleClick}
            buttonMessage={t('common.errorPage.refresh')}
          />
        </div>
      </div>
    </div>
  )
}

ErrorPage.propTypes = {
  removeError: PropTypes.func,
}

export default ErrorPage
